//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryEvaluationAnalysis } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '550px'
    },
    height: {
      type: String,
      default: '350px'
    },
    top: {
      type: String,
      default: '75px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '30px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {},
    selectType: {}
  },
  data: function data() {
    return {
      chart: 'pieChart'
    };
  },
  watch: {
    id: {
      handler: function handler(val) {// this.getData(this.type, val, 3, this.selectType)
      },
      immediate: true
    }
  },
  mounted: function mounted() {// this.initBarChart()
  },
  methods: {
    getData: function getData(type, id, queryType, selectType) {
      var _this = this;

      queryEvaluationAnalysis({
        type: type,
        id: id,
        queryType: queryType,
        selectType: selectType
      }).then(function (res) {
        if (res.success) {
          var trafficWay = [{
            name: '1星',
            value: res.result.oneStars
          }, {
            name: '2星',
            value: res.result.twoStars
          }, {
            name: '3星',
            value: res.result.threeStars
          }, {
            name: '4星',
            value: res.result.fourStars
          }, {
            name: '5星',
            value: res.result.fiveStars
          }];

          _this.initBarChart(trafficWay);
        }
      });
    },
    initBarChart: function initBarChart(trafficWay) {
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          textStyle: {
            color: '#fff'
          }
        },
        series: [{
          name: '',
          type: 'pie',
          radius: '50%',
          data: trafficWay,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(255, 255, 255, 0.5)'
            }
          }
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    }
  }
};